import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { HttpClientService } from './http-client.service';
import { HttpHeaders } from '@angular/common/http';
import { storageUtil } from 'src/app/utils';
import { BrowserService } from './browser.service';
import {
  API_CONSTANTS,
  storageConstant,
} from 'src/app/constants';
import { from } from 'rxjs';
import { IpService } from './ip.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user!: any;

  constructor(
    private http: HttpClientService,
    private _storage: storageUtil,
    private _browserService: BrowserService,
        private ipService: IpService
  ) {}

  login(credentials: any) {
    return this.http
      .post(`${API_CONSTANTS.AUTH}${API_CONSTANTS.LOGIN}`, credentials)
      .pipe(
        map((response: any) => {
          return response;
        }),
      );
  }

  /**
   * Login using authenticate-v2 endpoint with JWT token
   */
  loginV2(credentials: { email: string; password: string }) {
    return this.http.post(`/authenticate-v2/login`, credentials).pipe(
      map((response: any) => {
        if (response.success && response.data) {
          this._storage.setItem(
            response.data.token,
            storageConstant.LOGGED_IN_TOKEN,
          );
        }
        return response;
      }),
    );
  }

  register(body: any, type: string) {
    // return this.http
    //   .post(`${API_CONSTANTS.AUTH}${API_CONSTANTS.REGISTER}${type ?? ''}`, body)
    //   .pipe(
    //     map((response: any) => {
    //       return response.data;
    //     }),
    //   );

     // Get client IP and include it in the request headers
        return from(this.ipService.getClientIp()).pipe(
          switchMap((clientIp: string | null) => {
            // Build options with headers
            const options: any = {};
            
            if (clientIp) {
              const headers = new HttpHeaders().set('x-real-ip', clientIp);
              options.headers = headers;
            }
            
            return this.http.post(`${API_CONSTANTS.AUTH}${API_CONSTANTS.REGISTER}${type ?? ''}`, body, options).pipe(
              map((response: any) => {
                return response.data;
              }),
            );
          })
        );
  }

  registerFromReview(body: any) {
    return this.http.post(`${API_CONSTANTS.AUTH}/register-review`, body).pipe(
      map((response: any) => {
        return response.data;
      }),
    );
  }

  forgotPassword(body: any) {
    return this.http
      .post(`${API_CONSTANTS.AUTH}${API_CONSTANTS.RESET_PASSWORD}`, body)
      .pipe(
        map((response: any) => {
          return response;
        }),
      );
  }

  updatePasswordForSSO(data: any, token: string) {
    const headers = new HttpHeaders({ Authorization: token });
    return this.http
      .post('/authenicate/updatepassword', data, { headers })
      .pipe(
        map((response: any) => {
          return response.data;
        }),
      );
  }

  logout(isBrowser: boolean) {
    if (isBrowser) {
      localStorage.clear();
      sessionStorage.clear();
    }
    location.href = 'login';
  }

  isAuthenticated(): boolean {
    if (!this._browserService.checkBrowser()) {
      this.user = null;
      return false;
    }
    const loggedInUser = this._storage.getItem(storageConstant.LOGGED_IN_USER);
    const token = this._storage.getItem(storageConstant.LOGGED_IN_TOKEN);
    this.user = loggedInUser;
    return !!(loggedInUser && token);
  }
}
